import React from 'react';
import Image from 'next/image';
import Container from '@/components/ui/Container';
import SectionHeader from '@/components/ui/SectionHeader';
import { IHireRoles } from '@/components/type/hireUs/hireAiType';

type Props = {
  data: IHireRoles;
};

const HireRoles = ({ data }: Props) => {
  return (
    <section className="bg-black">
      <Container className="flex flex-col gap-10 pb-[100px]">
        <SectionHeader
          headingText={data.headingText}
          descriptionText={data.descriptionText}
          isSectionDark={true}
          className="mx-auto max-w-[927px] items-center"
        />
        <div className="flex flex-wrap gap-4 md:gap-5">
          {data.items.map((item) => (
            <div
              key={item.title}
              className="flex grow basis-full flex-col gap-4 rounded-lg border border-white/15 bg-[#161616] p-5 sm:basis-[calc(50%-10px)] lg:basis-[calc(33.333%-14px)] xl:basis-[calc(25%-15px)]"
            >
              <Image src={item.icon} alt={item.title} width={32} height={32} />
              <h3 className="text-lg font-medium leading-6 text-white">
                {item.title}
              </h3>
              <p className="text-sm leading-5 text-white/70">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default HireRoles;
